<template>
  <Tile :component-path="columnEditor.component"
        :form-data="formData"
        :editor-data="editorData"
        :loading="loading"
        v-model="inputValue"
        @ready="handleEditorReady"
        @error="handleEditorError"
        v-bind="$attrs"
        v-on="filteredListeners"></Tile>
</template>

<script>
import Tile from '../Tile'
import Emitter from 'element-ui/lib/mixins/emitter'
export default {
  mixins: [Emitter],
  name: 'DataGridColumnEditor',
  components: {
    Tile
  },
  props: {
    value: {
      required: true
    },
    isUpdate: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      required: true
    },
    columnEditor: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      editorReady: false,
      loading: false,
      editorData: null
    }
  },
  computed: {
    prepared: function () {
      return this.editorReady && !this.loading
    },
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
        this.dispatch('ElFormItem', 'el.form.blur', val)
      }
    },
    filteredListeners () {
      const { input, change, ...rest } = this.$listeners
      return rest
    }
  },
  methods: {
    handleEditorReady () {
      this.editorReady = true
    },
    handleEditorError () {
      this.$notify({
        title: '加载错误',
        message: '组件加载失败，请刷新页面重新加载',
        type: 'error'
      })
    },
    loadEditorData () {
      if (this.columnEditor.dataUrl) {
        let postParams = this.$extend(this.$attrs)
        let postId = this.formData.id
        if (postId) {
          postParams.postId = postId
        } else {
          if (this.isUpdate) {
            return
          }
        }
        this.loading = true
        this.$ajax({
          url: this.columnEditor.dataUrl,
          method: 'post',
          data: this.$qs.stringify(postParams, {
            arrayFormat: 'repeat'
          })
        }).then(response => {
          this.editorData = response.data
        }, () => {
          this.$message.error('获取列编辑数据失败')
        }).finally(() => {
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.loadEditorData()
  },
  watch: {
    'formData.id': function (val) {
      if (val) {
        this.$nextTick(() => this.loadEditorData())
      }
    },
    'prepared': {
      handler: function (val) {
        this.$emit('update:isLoading', !val)
      },
      immediate: true
    }
  }
}
</script>
